<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 17:44:43
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-08-05 09:49:02
 -->
<template>
  <div class="offlineTimes">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">日掉线次数</span>
    </div>
    <div class="offlineCharts" ref="offlineCharts"></div>
  </div>
</template>

<script>
export default {
  name: 'offlineTimes',
  components: {
  },
  data () {
    return {
      charts: '',
      // xAxis: ['4/15', '4/16', '4/17', '4/18', '4/19', '4/20', '4/21'],
      xAxis: [],
      // yAxis: [0, 1, 0, 0, 2, 3, 0],
      yAxis: [],
    }
  },
  methods: {
    /**
     * @description                   初始化图表
     * @return {undefied}             无返回值
     */
    initCharts () {
      this.charts = this.$echarts.init(this.$refs.offlineCharts)
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          name: '掉线次数（次）',
          type: 'value',
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        series: [{
          data: this.yAxis,
          type: 'line',
          color: '#eceb50',
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            color: '#eceb50',
          },
        }],
      }
      this.charts.setOption(options)
      window.onresize = () => {
        this.charts.resize()
      }
    },
    /**
     * @description                   获取日掉线次数数据
     * @return {undefied}             无返回值
     */
    getOfflineTimesData () {
      this.$http.get('/rest/screen/hlpz/device/offline')
        .then(res => {
          if (res.code === 0) {
            let xAxis = []
            let yAxis = []
            res.data.map(k => {
              xAxis.push(k.time)
              yAxis.push(k.number)
            })
            this.xAxis = xAxis
            this.yAxis = yAxis
            this.initCharts()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.getOfflineTimesData()
    this.initCharts()
    window.onresize = () => {
      this.charts.resize()
    }
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .offlineTimes {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 40px;
      font-size: 20px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .offlineCharts {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
</style>
